import React from 'react'
import { Layout, SectionTitle, Showcase, Header } from '../../../../components'

import './style.scss'
import data from './data.json'

export default () => {
  return (
    <>
      <Header
        site={data.site}
        slug={data.slug + '/design/'}
        state="design"
        title={data.title}
        exclusive={true}
      />
      <Layout
        description={data.description}
        site={data.site}
        slug={data.slug + '/design/'}
        state="design"
        title={data.title}
      >
        <SectionTitle>Usage</SectionTitle>
        <Showcase
          site={data.site}
          title="Label"
          text="Use the label when designing an input field not available in the Currency Input Field patterns. Best practice is to only use this styling on form fields for consistency and easy recognition."
        >
          <div class="c-label u-type--center">Label name</div>
        </Showcase>
        <hr />

        <SectionTitle>Design Environment</SectionTitle>
        <p>
          Keep a distance of at least 8 px between a label and the field it
          identifies whether it appears above or to the right of the input.
          Maximum length for a label title is one line of text at 280 px.
        </p>
        <hr />
        <SectionTitle>Microcopy</SectionTitle>
        <p>
          Labels should use as few words as possible. Use sentence case with no
          end punctuation unless the label is a question.
        </p>
      </Layout>
    </>
  )
}
